import React, { FC } from 'react'
import styles from './TableHeadCell.module.scss'

type TableHeadCellProps = React.ThHTMLAttributes<HTMLTableHeaderCellElement>

export const TableHeadCell: FC<TableHeadCellProps> = ({ children, ...props }) => {
  return (
    <th {...props} className={styles.tableHeadCell}>
      {children}
    </th>
  )
}

TableHeadCell.displayName = 'TableHeadCell'
